<template>
  <div v-show="shouldShowOpenDate">
    <translate
      v-if="isDateInSameYear(nextOpenDate)"
      :tt="{ nextOpenDate }"
      class="open-status"
    >
      Opens {nextOpenDateNoYear}
    </translate>
    <translate v-else :tt="{ nextOpenDate }" class="open-status">
      Opens {nextOpenDateYear}
    </translate>
  </div>
</template>

<script lang="ts">
import type { CampsiteDetails } from '../types'
import { isDateInSameYear, isDatePast } from '~/utility/date/relative'
import { Component, Prop, Vue, toNative } from '~/utility/pu-class-decorator'

@Component
class CampsiteNextOpen extends Vue {
  @Prop({ required: true })
  campsite: CampsiteDetails

  get shouldShowOpenDate() {
    return this.nextOpenDate && !isDatePast(this.nextOpenDate)
  }

  isDateInSameYear(date: string) {
    return isDateInSameYear(date)
  }

  get nextOpenDate() {
    if (
      this.campsite.openAllYear ||
      !this.campsite.openingDateRanges ||
      this.campsite.openingDateRanges.length === 0
    ) {
      return ''
    }
    const openingDates = this.campsite.openingDateRanges
      .map((range) => range.openingDate)
      .sort()

    return openingDates[0]
  }
}

export default toNative(CampsiteNextOpen)
</script>

<style scoped>
.open-status {
  font-size: var(--body);
  color: var(--colour-orange);
}
</style>
